import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Modal from '../../components/Modal';
import {markAsDud} from '../../actions/ClientActions';
import Assert from '../../assert/Assert';
import {BootstrapForm, FormGroup} from '../bootstrap/Form';
import ClientCloseOffReasonsSelect from './ClientCloseOffReasonsSelect';

@connect(
    state => ({
        isSaving: state.modal.markingAsDud
    }),
    dispatch => bindActionCreators({markAsDud}, dispatch)
)
export default class ConfirmMarkAsDudModal extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            reasons: [],
            closeOffNotes: '',
            showAddFeatureField: false,
            showAddReasonField: false,
            newFeatureText: '',
            newReasonText: '',
            inputs: {
                closeOffNotes: {
                    value: '',
                    validators: [{
                        rule: Assert.minLength(1),
                        errorMessage: 'Please enter a note'
                    }]
                },
                closeOffReasons: {
                    value: [],
                    validators: [{
                        rule: input => input.length > 0,
                        errorMessage: 'Please select close off reasons'
                    }]
                }
            },
            errors: {}
        };
    }
    handleSubmit(e) {
        if(e) {
            e.preventDefault();
        }

        if(this.isValid()) {
            this.props.markAsDud(this.props.client.id, this.refs.form.getFormData());
        }
    }
    isValid() {
        var isValid = this.refs.form.isValid();
        if(! isValid) {
            this.setState({errors: this.refs.form.getErrors()});
        }
        return isValid;
    }
    handleChange(e) {
        var inputs = this.state.inputs;
        inputs[e.target.name].value = e.target.value;
        this.setState({inputs});
    }
    handleCloseOffReasonsChange(closeOffReasonIds) {
        console.log('WO', closeOffReasonIds);
        var inputs = this.state.inputs;
        inputs.closeOffReasons.value = closeOffReasonIds;
        this.setState({inputs});
    }
    render() {
        var actionButton = this.props.isSaving ?
            (<button className="btn btn-danger disabled">Marking as dud...</button>) :
            (<button className="btn btn-danger" onClick={this.handleSubmit.bind(this)}>Mark as dud</button>);


        return (
            <Modal actionButton={actionButton} className="modal-danger" title={"Confirm mark as dud"}>
                <BootstrapForm ref="form" onSubmit={this.handleSubmit.bind(this)} inputs={this.state.inputs} className="form-horizontal">
                    <FormGroup defaultText='Close off notes' errors={this.state.errors.closeOffNotes}>
                        <textarea
                               name='closeOffNotes'
                               className="form-control"
                               onChange={this.handleChange.bind(this)}
                               value={this.state.inputs.closeOffNotes.value} />
                    </FormGroup>


                    <FormGroup defaultText='Close off reasons' errors={this.state.errors.closeOffReasons}>
                        <ClientCloseOffReasonsSelect
                            value={this.state.inputs.closeOffReasons.value}
                            onChange={this.handleCloseOffReasonsChange.bind(this)} />
                    </FormGroup>
                </BootstrapForm>
            </Modal>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/clients/ConfirmMarkAsDudModal.js